import {ApolloClient} from 'apollo-client'
import {HttpLink} from 'apollo-link-http'
import {WebSocketLink} from 'apollo-link-ws'
import {setContext} from 'apollo-link-context'
import {getMainDefinition} from 'apollo-utilities'
import {InMemoryCache} from 'apollo-cache-inmemory'
import {split} from 'apollo-link'
import fetch from 'isomorphic-unfetch'
import {ApolloLink} from 'apollo-link'
import {withClientState} from 'apollo-link-state';
import {createUploadLink} from 'apollo-upload-client'

import editProjectQuery from '../queries/server/project'
import editClientQuery from '../queries/server/client'
import editUserQuery from '../queries/server/user'
import editUserRoleQuery from '../queries/server/user_role'
import projectInvoicingQuery from '../queries/reports/project_invoicing'
import editInvoiceQuery from '../queries/server/project_client_invoice'
import projectInvoice from '../queries/server/project_invoice'
import projectSupplierInvoice from '../queries/server/project_supplier_invoice'
import userExpensesQuery from '../queries/server/user_project_expenses'
import editNotification from '../queries/server/notification'
import annualLeaveRecordQuery from '../queries/server/annual_leave_record'


import create_schedule from '../queries/client_side/create_schedule'
import edit_schedule from '../queries/client_side/edit_schedule'
import project_client_invoice from '../queries/client_side/project_client_invoice'
import system_setting from '../queries/server/system_setting'
import userDashboardQuery from '../queries/user_dashboard'

import entityCleaner from "./entityCleaner";

// This is the same cache you pass into new ApolloClient
const cache = new InMemoryCache({addTypename: false}).restore({})

const stateLink = withClientState({
    cache,
    defaults: {
        createSchedule: {
            start_date: null,
            end_date: null,
            user_schedule_type_id: 1,
            user_id: null,
            project_activity_budget_id: null
        },
        editSchedule: {
            id: null,
            start_date: null,
            end_date: null,
            user_schedule_type_id: null,
            user_id: null,
            project_activity_budget_id: null,
            active: null
        },
        projectClientInvoice: {
            project_id: null,
            name: null,
            project_clients: [],
            project_client_budgets: []
        }
    },
    resolvers: {
        Mutation: {

            updateEditUserExpenses: (_, {data, user_id, is_paid}, {cache}) => {
                console.log('updateEditUserExpenses', data)

                const {user_project_expenses} = cache.readQuery({
                    query: userExpensesQuery,
                    variables: {user_id, is_paid}
                })

                console.log('read', user_project_expenses)

                const index = user_project_expenses.findIndex(({id}) => id === data.id)

                console.log('users', user_id, data.user_id)

                if(user_id == data.user_id || !user_id){

                    console.log('match')

                    let newData = []

                    if (index === -1) {
                        //add new record

                        newData = [...user_project_expenses, {...data}]
                    }
                    else {
                        //update existing record
                        newData = [
                            ...user_project_expenses.slice(0, index),
                            {...data},
                            ...user_project_expenses.slice(index + 1)
                        ]
                    }

                    cache.writeQuery({
                        query: userExpensesQuery,
                        data: {user_project_expenses: newData},
                        variables: {user_id, is_paid}
                    })

                    return newData
                }

            },

            deleteUserExpense: (_, {id, user_id, is_paid}, {cache}) => {
                const {user_project_expenses} = cache.readQuery({
                    query: userExpensesQuery,
                    variables: {user_id, is_paid}
                })

                const index = user_project_expenses.findIndex((expense) => expense.id === id)

                let newData  = [
                    ...user_project_expenses.slice(0, index),
                    ...user_project_expenses.slice(index + 1)
                ]

                cache.writeQuery({
                    query: userExpensesQuery,
                    data: {user_project_expenses: newData},
                    variables: {user_id, is_paid}
                })

                return newData
            },

            updateSystemSetting: (_, {data}, {cache}) => {
                console.log('updateSystemSetting', data)

                cache.writeQuery({
                    query: system_setting,
                    data: {system_setting: data},
                    variables: {id: data.id}
                })

                return data
            },

            updateInvoice: (_, {data}, {cache}) => {


                console.log('update Invoice 1', data)

                const {project_client_invoice} = cache.readQuery({
                    query: editInvoiceQuery,
                    variables: {id: data.id}
                })

                const newData = {...project_client_invoice, ...data}

                console.log('updateInvoice', data, project_client_invoice, newData)

                cache.writeQuery({
                    query: editInvoiceQuery,
                    data: {project_client_invoice: newData},
                    variables: {id: data.id}
                })

                return data

            },
            updateEditProject: (_, {data}, {cache}) => {
                console.log('editProject', data)

                console.log('readCache', cache.readQuery({
                    query: editProjectQuery,
                    variables: {project_id: data.project_id}
                }))

                cache.writeQuery({
                    query: editProjectQuery,
                    data: {project: data},
                    variables: {project_id: data.project_id}
                })
                return data
            },
            removeProjectClientInvoice: (_, {invoice_id, project_id}, {cache}) => {

                const {project} = cache.readQuery({
                    query: editProjectQuery,
                    variables: {project_id}
                })
                const newProject = {
                    ...project,
                    invoices: [
                        ...project.invoices.filter(invoice => invoice.id !== invoice_id)
                    ]
                }

                cache.writeQuery({
                    query: editProjectQuery,
                    data: {project: newProject},
                    variables: {project_id}
                })
                return newProject

            },
            removeProjectClientInvoiceCreditNote: (_, {invoice_id, credit_note_id, project_id}, {cache}) => {
                const {project} = cache.readQuery({
                    query: editProjectQuery,
                    variables: {project_id}
                })

                const index = project.invoices.findIndex(({id}) => id === invoice_id)
                const invoice = project.invoices[index]
                const newInvoice = {
                    ...invoice,
                    credit_notes: invoice.credit_notes.filter(cn => cn.id === credit_note_id)
                }

                const newProject = {
                    ...project,
                    invoices: [
                        ...project.invoices.slice(0, index),
                        {...newInvoice},
                        ...project.invoices.slice(index + 1)
                    ]
                }

                cache.writeQuery({
                    query: editProjectQuery,
                    data: {project: newProject},
                    variables: {project_id}
                })
                return newProject
            },
            updateEditClient: (_, {data}, {cache}) => {
                console.log('editClient', data, cache)

                console.log('readCache', cache.readQuery({
                    query: editClientQuery,
                    variables: {client_id: data.client_id.toString()}
                }))

                cache.writeQuery({
                    query: editClientQuery,
                    data: {client: data},
                    variables: {client_id: data.client_id.toString()}
                })
                return data
            },
            updateEditUser: (_, {data}, {cache}) => {
                cache.writeQuery({
                    query: editUserQuery,
                    data: {user: data},
                    variables: {user_id: data.user_id.toString()}
                })
                return data
            },
            updateUserRole: (_, {data}, {cache}) => {
                console.log('updateUserRole', data)
                cache.writeQuery({
                    query: editUserRoleQuery,
                    data: {user_role: data},
                    variables: {user_role_id: data.user_role_id.toString()}
                })
                return data
            },
            editCreateSchedule: (_, {data}, {cache}) => {

                const currentCreateSchedule = cache.readQuery({query: create_schedule})

                let createSchedule = {
                    ...currentCreateSchedule.editCreateSchedule,
                    ...data
                }

                createSchedule = entityCleaner(createSchedule)
                cache.writeData({data: {createSchedule}})

                return createSchedule
            },
            setSchedule: (_, {data}, {cache}) => {
                const currentEditSchedule = cache.readQuery({query: edit_schedule})

                let editSchedule = {
                    ...currentEditSchedule.editSchedule,
                    ...data,
                    //project_activity_budget_id: (data.user_project_activities.length) ? data.user_project_activities[0].project_activity_budget_id : null,
                }

                editSchedule = entityCleaner(editSchedule)
                cache.writeData({data: {editSchedule}})

                return editSchedule
            },

            editSchedule: (_, {data}, {cache}) => {
                const currentEditSchedule = cache.readQuery({query: edit_schedule})

                let editSchedule = {
                    ...currentEditSchedule.editSchedule,
                    ...data,
                }

                editSchedule = entityCleaner(editSchedule)
                cache.writeData({data: {editSchedule}})

                return editSchedule
            },

            setProjectClientInvoice: (_, {data}, {cache}) => {
                console.log('setProjectClientInvoice', data)

                const projectClientInvoice = {
                    ...data
                }

                cache.writeData({data: {projectClientInvoice}})
                return projectClientInvoice
            },

            editProjectClientInvoiceValue: (_, {client_id, project_activity_budget_id, description, amount}, {cache}) => {

                console.log(client_id, project_activity_budget_id, description, amount)

                const currentData = cache.readQuery({query: project_client_invoice})
                const {project_client_budgets} = currentData.projectClientInvoice

                const budgetIndex = project_client_budgets
                    .findIndex(budget => budget.client_id === client_id &&
                        budget.project_activity_budget_id == project_activity_budget_id)

                console.log('index', budgetIndex)

                const updatedBudget = {
                    ...project_client_budgets[budgetIndex],
                    //project_activity_type: {description},
                    budget_label: description,
                    amount_to_invoice: parseFloat(amount)
                }

                console.log('updatedBudget', updatedBudget)

                const projectClientInvoice = {
                    ...currentData.projectClientInvoice,
                    project_client_budgets: [
                        ...project_client_budgets.slice(0, budgetIndex),
                        {...updatedBudget},
                        ...project_client_budgets.slice(budgetIndex + 1)
                    ]
                }

                console.log('projectClientInvoice', projectClientInvoice)

                cache.writeData({data: {projectClientInvoice}})
                return projectClientInvoice
            },

            editProjectInvoice: (_, {project_id, client_id, project_activity_budget_id, description, amount}, {cache}) => {

                console.log(client_id, project_activity_budget_id, description, amount)

                const currentData = cache.readQuery({query: projectInvoice, variables: {project_id}})

                console.log('currentData', currentData)

                const {project_client_budgets} = currentData.projectInvoice

                const budgetIndex = project_client_budgets
                    .findIndex(budget => budget.client_id === client_id &&
                        budget.project_activity_budget_id == project_activity_budget_id)

                console.log('index', budgetIndex)

                const updatedBudget = {
                    ...project_client_budgets[budgetIndex],
                    budget_label: description,
                    amount_to_invoice: parseFloat(amount)
                }

                console.log('updatedBudget', updatedBudget)

                const newProjectInvoice = {
                    ...currentData.projectInvoice,
                    project_client_budgets: [
                        ...project_client_budgets.slice(0, budgetIndex),
                        {...updatedBudget},
                        ...project_client_budgets.slice(budgetIndex + 1)
                    ]
                }

                console.log('newProjectInvoice', newProjectInvoice)

                cache.writeQuery({
                    query: projectInvoice,
                    data: {projectInvoice: newProjectInvoice},
                    variables: {project_id}
                })
                return newProjectInvoice
            },

            editProjectInvoicePrefix: (_, {project_id, client_id, invoice_prefix}, {cache}) => {
                //, invoice_prefix: $invoice_prefix
                const currentData = cache.readQuery({query: projectInvoice, variables: {project_id}})

                const {project_clients} = currentData.projectInvoice

                const clientIndex = project_clients.findIndex(({client}) => client.client_id === client_id)

                const updatedClient = {
                    client: {...project_clients[clientIndex].client, invoice_prefix},
                }

                console.log('updatedClient', updatedClient)

                const newProjectInvoice = {
                    ...currentData.projectInvoice,
                    project_clients: [
                        ...project_clients.slice(0, clientIndex),
                        {...updatedClient},
                        ...project_clients.slice(clientIndex + 1)
                    ]
                }

                cache.writeQuery({
                    query: projectInvoice,
                    data: {projectInvoice: newProjectInvoice},
                    variables: {project_id}
                })
                return newProjectInvoice
            },

            editProjectSupplierInvoice: (_, {project_id, project_activity_budget_id, description, amount}, {cache}) => {

                console.log('editProjectSupplierInvoice')

                const currentData = cache.readQuery({query: projectSupplierInvoice, variables: {project_id}})

                const {project_activity_budgets} = currentData.projectSupplierInvoice

                const budgetIndex = project_activity_budgets
                    .findIndex(budget => budget.project_activity_budget_id == project_activity_budget_id)

                const updatedBudget = {
                    ...project_activity_budgets[budgetIndex],
                    //project_activity_type: {description},
                    budget_label: description,
                    amount_to_invoice: parseFloat(amount)
                }

                const newProjectInvoice = {
                    ...currentData.projectSupplierInvoice,
                    project_activity_budgets: [
                        ...project_activity_budgets.slice(0, budgetIndex),
                        {...updatedBudget},
                        ...project_activity_budgets.slice(budgetIndex + 1)
                    ]
                }

                cache.writeQuery({
                    query: projectSupplierInvoice,
                    data: {projectSupplierInvoice: newProjectInvoice},
                    variables: {project_id}
                })
                return newProjectInvoice
            },

            removeProjectInvoiceClient: (_, {project_id, client_id}, {cache}) => {
                const currentData = cache.readQuery({query: projectInvoice, variables: {project_id}})

                const {project_clients} = currentData.projectInvoice

                const newProjectInvoice = {
                    ...currentData.projectInvoice,
                    project_clients: [
                        ...project_clients.filter(({client}) => client.client_id !== client_id)
                    ]
                }

                cache.writeQuery({
                    query: projectInvoice,
                    data: {projectInvoice: newProjectInvoice},
                    variables: {project_id}
                })
                return newProjectInvoice
            },

            updateProjectClientInvoices: (_, {data}, {cache}) => {

                const {report_project_invoicing} = cache.readQuery({query: projectInvoicingQuery})
                const index = report_project_invoicing.findIndex(p => p.project_id === data.project_id)

                const newData = [
                    ...report_project_invoicing.slice(0, index),
                    {...report_project_invoicing[index], ...data},
                    ...report_project_invoicing.slice(index + 1)
                ]

                console.log(newData)

                cache.writeData({data: {report_project_invoicing: newData}})
            },

            updateProjectInvoiceAmount: (_, {project_id, amount}, {cache}) => {

                const {report_project_invoicing} = cache.readQuery({query: projectInvoicingQuery})
                const index = report_project_invoicing.findIndex(p => p.project_id === project_id)


                const newData = [
                    ...report_project_invoicing.slice(0, index),
                    {...report_project_invoicing[index], amount_to_invoice: amount},
                    ...report_project_invoicing.slice(index + 1)
                ]

                console.log(newData)

                cache.writeData({data: {report_project_invoicing: newData}})
                //cache.writeQuery({query: editUserRoleQuery, data: {user_role: data}, variables: {user_role_id: data.user_role_id.toString()}})
            },

            removeProjectInvoice: (_, {project_id}, {cache}) => {
                const {report_project_invoicing} = cache.readQuery({query: projectInvoicingQuery})

                console.log(project_id, report_project_invoicing.filter((project) => project.project_id !== project_id))

                const newData = [
                    ...report_project_invoicing.filter((project) => project.project_id !== project_id),
                ]

                console.log(newData)

                cache.writeData({data: {report_project_invoicing: newData}})
                return newData
            },

            editNotification: (_, {data}, {cache}) => {
                console.log('editNotification', data, cache)
                cache.writeQuery({
                    query: editNotification,
                    data: {notification: data},
                    variables: {id: data.id}
                })
                console.log('cache after', cache)
                return data
            },

            updateAnnualLeave: (_, {data}, {cache}) => {
                cache.writeQuery({
                    query: annualLeaveRecordQuery,
                    data: {annual_leave_record: {
                        ...data,
                        start_of_day: !!parseInt(data.start_of_day),
                        end_of_day: !!parseInt(data.end_of_day)
                    }},
                    variables: {id: data.id}
                })
                return data
            },

            toggleDashboardWidget: (_, {widget, toggle, user_id}, {cache}) => {
                console.log(widget, toggle, user_id)
                const {user} = cache.readQuery({query: userDashboardQuery, variables: {user_id}})

                const newUser = {
                    ...user,
                    dashboard_widgets: (toggle) ? [...user.dashboard_widgets, widget] : [...user.dashboard_widgets.filter(({id}) => id !== widget.id)]
                }

                cache.writeQuery({
                    query: userDashboardQuery,
                    data: {user: newUser},
                    variables: {user_id}
                })
                return newUser
            }
        }
    }
})

let link = null

function resolveWsUrl(url) {
    if (!url) return url
    if (url.startsWith('ws://') || url.startsWith('wss://')) return url
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    return `${protocol}//${window.location.host}${url}`
}

//const httpLink = new HttpLink({
const httpLink = createUploadLink({

    credentials: 'same-origin',
    /*headers: {
        'Authorization': `Bearer ${getCookie('token')}`
    },*/
    uri: process.env.REACT_APP_API_URL,
})

const wsLink = new WebSocketLink({
    uri: resolveWsUrl(process.env.REACT_APP_WS_URL),
    credentials: 'same-origin',
    options: {
        reconnect: true,
        connectionParams: () => {
            const user = JSON.parse(sessionStorage.getItem('user'))
            return {
                authToken: user && user.hasOwnProperty('token') ? user.token : ''
            }
        }
    }
})

//const uploadLink = createUploadLink({ uri: 'http://localhost:4000/graphql' })

const authLink = setContext((_, {headers}) => {
    const user = JSON.parse(sessionStorage.getItem('user'))

    return {
        headers: {
            ...headers,
            authorization: user && user.hasOwnProperty('token') ? `Bearer ${user.token}` : ''
        }
    }
})

link = split(
    // split based on operation type
    ({query}) => {
        const {kind, operation} = getMainDefinition(query);
        return kind === 'OperationDefinition' && operation === 'subscription';
    },
    wsLink,
    httpLink,
)


const client = new ApolloClient({
    link: ApolloLink.from([stateLink, authLink.concat(link)]),
    cache,
})

export default client